import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from './stores/AuthStore';
import { LoginPage } from './pages/LoginPage';
// import { BookingsPage } from './pages/BookingsPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import './styles/App.css';
import { SettingsPage } from './pages/SettingsPage';
import { DashboardPage } from './pages/DashboardPage';

export const App: React.FC = observer(() => {
    useEffect(() => {
        // Check if user is already authenticated on app load
        const verifyToken = async () => {
            await authStore.checkAuth();
        }
        verifyToken();
    }, []);

    return (
        <Router>
            <Routes>
                {/* Public route */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected routes */}
                <Route
                    path="/calendar"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <DashboardPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />

                {/* <Route
                    path="/bookings"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <BookingsPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                /> */}

                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <SettingsPage />
                            </Layout>
                        </ProtectedRoute>
                    }
                />

                {/* Catch-all: redirect to calendar if authenticated, otherwise to login */}
                <Route
                    path="/"
                    element={
                        authStore.isAuthenticated ? <Navigate to="/calendar" /> : <Navigate to="/login" />
                    }
                />

                {/* 404 redirect */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
});
